module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "copyright"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright1",
    attrs: {
      "id": "copy_p1"
    }
  }, [_vm._v("The University of Chicago Press, Chicago, 60637"), _c('br'), _vm._v("\n© 1967 by Richard Stark"), _c('br'), _vm._v("\nForeword © 2009 by Luc Sante"), _c('br'), _vm._v("\nAll rights reserved."), _c('br'), _vm._v("\nUniversity of Chicago Press edition 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p2"
    }
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p3"
    }
  }, [_vm._v("18 17 16 15 14 13 12 11 10 09     1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p4"
    }
  }, [_vm._v("ISBN-13: 978-0-226-77107-6 (paper)"), _c('br'), _vm._v("\nISBN-10: 0-226-77107-5 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p5"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p6"
    }
  }, [_vm._v("Stark, Richard, 1933–2008."), _c('br'), _vm._v("\n The rare coin score / Richard Stark ; with a new foreword by Luc Sante."), _c('br'), _vm._v("\n     p. cm."), _c('br'), _vm._v("\n Summary: Parker makes the mistake of letting an amateur in on the score, and one of them is a pretty woman named Claire."), _c('br'), _vm._v("\n ISBN-13: 978-0-226-77107-6 (pbk. : alk. paper)"), _c('br'), _vm._v("\n ISBN-10: 0-226-77107-5 (pbk. : alk. paper) 1. Parker (Fictitious character)—Fiction. 2. Criminals—Fiction. I. Sante, Luc. II. Title."), _c('br'), _vm._v("\n PS3573.E9R37 2009"), _c('br'), _vm._v("\n 813′.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-right",
    attrs: {
      "id": "copy_p7"
    }
  }, [_vm._v("2009006774")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/infin.jpg"
    }
  }), _vm._v(" The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1992.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "copy_p9"
    }
  }, [_vm._v("ISBN 978-0-226-77292-9 (electronic)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851a313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0